const globalColors = {
  codeInk: "#101F4E",
  flashLoot: "#98FF98",
  flexLight: "#FFCB21",
  vaultGold: "#FFC93F",
  winterDustDrop: "#F5F3EF",
};

// export const globalGradientDarkColors={
//   goldLegendary:"linear-gradient(330deg, rgba(28, 25, 17, 0.50) 6.49%, rgba(52, 47, 33, 0.50) 92.83%",
//   purpleEpic:"linear-gradient(330deg, rgba(27, 20, 35, 0.50) 6.49%, rgba(44, 34, 57, 0.50) 92.83%)",
//   blueRare:"linear-gradient(330deg, rgba(6, 14, 40, 0.50) 6.49%, rgba(18, 30, 68, 0.50) 92.83%)",
//   greenUncomman:"linear-gradient(330deg, rgba(0, 20, 22, 0.50) 6.49%, rgba(1, 45, 49, 0.50) 92.83%)",
//   commanGray:"linear-gradient(329.62deg, rgba(25, 25, 25, 0.5) 6.49%, rgba(39, 39, 39, 0.5) 92.83%)"
// }

export const globalGradientDarkColors = {
  goldLegendary: "linear-gradient(153deg, #413201 0.93%, #171717 51.59%)",
  purpleEpic: "linear-gradient(153deg, #281337 0.93%, #1A1A1A 51.59%)",
  blueRare: "linear-gradient(153deg, #2A1B6B 0.93%, #1A1A1A 51.59%)",
  greenUncomman: "linear-gradient(153deg, #034517 0.93%, #1A1A1A 51.59%)",
  commanGray: "linear-gradient(153deg, #313131 0.93%, #1A1A1A 51.59%)",
};

export const globalGradientDarkColorsWheel = {
  goldLegendary: "linear-gradient(180deg, #584402 0%, #1A1A1A 100%)",
  purpleEpic: "linear-gradient(180deg, #3E1D55 0%, #1A1A1A 101.74%)",
  blueRare: "linear-gradient(180deg, #362291 0%, #1A1A1A 100%)",
  greenUncomman: "linear-gradient(180deg, #045E1F 0%, #1A1A1A 100%)",
  commanGray: " linear-gradient(180deg, #4E4E4E 0%, #1A1A1A 100%)",
};

export const globalGradientLightColors = {
  softVanillaGlow: "linear-gradient(180deg, #faf6ef, #fbefcc)",
  softLilacRadiance: "linear-gradient(180deg, #eee1ff, #dabdff)",
  softPeriwinkleGlow: "linear-gradient(180deg, #dde4ff, #c9d5ff)",
  softCyanRadiance: "linear-gradient(180deg, #e9fdff, #c1fbff)",
  softGrayGlow: "linear-gradient(135deg, #f0f0f0, #b6b6b6)",
};

export const globalGradientLightColorsWheel = {
  goldLegendary:
    "linear-gradient(180deg, rgb(250, 246, 239) 6.49%, rgb(251, 239, 204) 172.83%)",
  purpleEpic:
    "linear-gradient(180deg, rgb(238, 225, 255) 6.49%, rgb(218, 189, 255) 172.83%)",
  blueRare:
    "linear-gradient(180deg, rgb(221, 228, 255) 6.49%, rgb(201, 213, 255) 92.83%)",
  greenUncomman:
    "linear-gradient(180deg,rgb(233, 253, 255) 6.49%, rgb(193, 251, 255) 282.83%)",
  commanGray: "linear-gradient(135deg, rgb(240, 240, 240), rgb(182, 182, 182))",
};
export const getPriceDarkHoverColor = (price) => {
  if (price <= 20)
    return "linear-gradient(153deg, #4E4E4E 0.93%, #1A1A1A 51.59%)";
  if (price <= 50)
    return "linear-gradient(153deg, #045E1F 0.93%, #1A1A1A 51.59%)";
  if (price <= 250)
    return "linear-gradient(153deg, #362291 0.93%, #1A1A1A 51.59%)";
  if (price <= 2000)
    return "linear-gradient(153deg, #3E1D55 0.93%, #1A1A1A 51.59%)";
  return "linear-gradient(153deg, #584402 0.93%, #1A1A1A 51.59%)";
};
export const getPriceDarkBorderColor = (price) => {
  if (price <= 20) return "#A6A6A6";
  if (price <= 50) return "#05BA3C";
  if (price <= 250) return "#6F6FFF";
  if (price <= 2000) return "#A05BD2";
  return "#CA9B00";
};
export const FAILED = "failed";
export const WAITING = "waiting";
export const SENDING = "sending";
export const EXPIRED = "expired";
export const PENDING = "pending";
export const FINISHED = "finished";
export const REJECTED = "rejected";
export const VERIFIED = "verified";
export const COMPLETED = "completed";
export const CONFIRMED = "confirmed";
export const CONFIRMING = "confirming";
export const UNVERIFIED = "unverified";
export const PARTIALLY_PAID = "partially_paid";
export const FURTHER_VERIFICATION = "further_verification";

export const STORAGE_KEY = "privacyBannerDismissed";
export const TEN_MB_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const SOCIAL_TOAST_KEY = "social_auth_toast_shown";

// 🔴 General errors
export const error_reason_ip_blocked =
  "Your access has been restricted due to IP limitations. Please contact support if this is a mistake.";

export const error_reason_account_inactive =
  "Your account is currently inactive. Please verify your account or contact support.";

export const error_reason_account_blocked =
  "Your account has been blocked. Please contact support for further assistance.";

export const error_reason_no_role =
  "Your account does not have an assigned role. Please contact support.";

export const error_reason_invalid_role =
  "Your account role is invalid. Please contact support.";

// 🔴 Social auth errors
export const error_reason_social_auth_failed =
  "Social authentication failed. Please try again.";

export const error_reason_social_email_not_found =
  "Email not found. Please try another login method.";

// 🟢 Success
export const success_reason_social_login = "Social authentication successful.";

// mobile screen min size
export const isMobile = window.innerWidth <= 480;

export default globalColors;
